import axios from 'axios';
import Cookies from 'js-cookie';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';
import i18n from 'i18next';

// Import helpers
import { checkErrorStatus } from 'services/helpers';
import { LOCALSTORAGE_USER, COOKIE_TOKEN } from 'helpers/variables';
import { getDeviceUID } from 'helpers/headers';

const uuid = getDeviceUID();

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'API-DeviceUID': uuid,
		'API-Device': `${browserName}; ${browserVersion}; ${osName}; ${osVersion}; ${osName}; ${osVersion};`
	},
	params: {
		platform: 'BROWSER'
	}
});

instance.interceptors.request.use(
	async function (config) {
		const user = JSON.parse(localStorage.getItem(LOCALSTORAGE_USER) ?? '{}');
		const token = user?.token ?? Cookies.get(COOKIE_TOKEN);

		// query params
		config.params = config.params || {};
		config.params.language = i18n.language;
		config.params.rating = user?.parental_control_rating || null;
		config.params.system = config.data?.system ?? config.params.system ?? user?.system ?? process.env.REACT_APP_SYSTEM;

		// headers
		config.headers.Authorization = token ? `Bearer ${token}` : null;

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use((response) => response, checkErrorStatus);

export default instance;
